import { GenericBackendResponse } from '../../genericBackendResponse';

export interface SaveHoldedApiKeyInput {
	holdedApiKey: string;
}

export const saveHoldedApiKey = async (
	token: string,
	holdedApiKey: string
): Promise<GenericBackendResponse<any>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/thirdparty/holded/api-key`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify({ holdedApiKey })
	});
	return response.json();
};
